function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ItemFocusWhen, useSetItemsFocusWhenMutation } from "sprout-graphql";
import { useCallback, useMemo, useState } from "react";
import { getItemUrl } from "sprout-lib";
import { useActionRegistryGlobalHandler, useNavigationList, useNavigationListItem } from "@sprout/list-navigation";
import Post from "@sprout/client-components/dist/Post";
import { useHistory } from "react-router-dom";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { useSetItemsArchived, useSetItemsDeleted } from "@sprout/client-graphql";
import { MoveItemsDialog } from "@sprout/client-components/dist/Dialog_next";
import { useTopicPage } from "../TopicPageContext";
const TopicPageViewsLabelPostsPost = (props)=>{
    const { post , index  } = props;
    const { id  } = post;
    const { helpers , navProps  } = useNavigationListItem(String(id), useMemo(()=>({
            object: post,
            index
        }), [
        post,
        index
    ]));
    return /*#__PURE__*/ _jsx("div", _objectSpread({}, navProps, {
        children: /*#__PURE__*/ _jsx(Post, {
            navigationItemHelpers: helpers,
            post: post,
            showTeam: false,
            showPseudoBreadcrumbs: true
        }, post.nodeId)
    }));
};
const makeHandleError = (command, itemIds)=>{
    return ()=>{
        console.error(`Failed to ${command} items: ${itemIds}`);
    };
};
const SUPPORTED_ACTIONS = [
    "FOCUS_DESCRIPTION",
    "FOCUS_NOTE",
    "OPEN",
    "OPEN_EXTERNAL", 
];
const TopicPageViewsLabelPosts = (props)=>{
    const { posts , updateList , skip =[]  } = props;
    const { isPartOfTopic , isOwnerOrAdmin  } = useTopicPage();
    const currentUser = useCurrentUser();
    const history = useHistory();
    const handlePostSingularAction = useCallback((command, activeItem)=>{
        if (!activeItem) return false;
        switch(command){
            case "FOCUS_DESCRIPTION":
            case "FOCUS_NOTE":
                {
                    var ref;
                    const isPostEditable = isOwnerOrAdmin || isPartOfTopic && ((ref = activeItem.owner) === null || ref === void 0 ? void 0 : ref.id) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
                    if (isPostEditable) {
                        history.push({
                            pathname: getItemUrl(activeItem),
                            state: {
                                [command === "FOCUS_DESCRIPTION" ? "focusDescriptionEditor" : "focusNoteEditor"]: true
                            }
                        });
                        return true;
                    }
                    return false;
                }
            default:
                return false;
        }
    }, [
        currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
        history,
        isOwnerOrAdmin,
        isPartOfTopic
    ]);
    const { Provider , navProps  } = useNavigationList("TopicPageViewsLabelsPosts", useMemo(()=>({
            actions: SUPPORTED_ACTIONS,
            multiselect: true,
            performSingularAction: handlePostSingularAction
        }), [
        handlePostSingularAction
    ]));
    const setItemsArchived = useSetItemsArchived();
    const setItemsDeleted = useSetItemsDeleted();
    useActionRegistryGlobalHandler([
        "ARCHIVE",
        "DELETE"
    ], useCallback((items, _event, command)=>{
        const itemIds = items.map((item)=>item.id);
        console.log(`${command} items:`, itemIds);
        if (itemIds.length === 0) return false;
        switch(command){
            case "ARCHIVE":
                if (updateList) updateList(itemIds);
                setItemsArchived({
                    items: [
                        ...items
                    ],
                    isExplicitlyArchived: true
                });
                return true;
            case "DELETE":
                if (updateList) updateList(itemIds);
                setItemsDeleted({
                    items: [
                        ...items
                    ],
                    isExplicitlyDeleted: true
                });
                return true;
            default:
                return false;
        }
    }, [
        setItemsArchived,
        setItemsDeleted,
        updateList
    ]));
    const [setItemsFocusWhen] = useSetItemsFocusWhenMutation();
    useActionRegistryGlobalHandler([
        "SET_SET_ASIDE",
        "SET_DONE"
    ], useCallback((items, _event, command)=>{
        const itemIds = items.map((item)=>item.id);
        if (itemIds.length === 0) return false;
        switch(command){
            case "SET_SET_ASIDE":
            case "SET_DONE":
                setItemsFocusWhen({
                    variables: {
                        userItemPreferences: itemIds.map((itemId)=>({
                                itemId,
                                focusWhen: command === "SET_SET_ASIDE" ? ItemFocusWhen.Later : null
                            }))
                    }
                }).catch(makeHandleError(command, itemIds));
                return true;
            default:
                return false;
        }
    }, [
        setItemsFocusWhen
    ]), {
        skip: skip.includes("SET_SET_ASIDE") || skip.includes("SET_DONE")
    });
    const [selectedItemsToMove, setSelectedItemsToMove] = useState([]);
    useActionRegistryGlobalHandler("MOVE", useCallback((items)=>{
        setSelectedItemsToMove([
            ...items
        ]);
        return true;
    }, []), {
        skip: skip.includes("MOVE")
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            selectedItemsToMove.length !== 0 && /*#__PURE__*/ _jsx(MoveItemsDialog, {
                selectedItems: selectedItemsToMove,
                open: selectedItemsToMove.length !== 0,
                onRequestClose: ()=>{
                    setSelectedItemsToMove([]);
                }
            }),
            /*#__PURE__*/ _jsx("div", _objectSpread({}, navProps, {
                children: /*#__PURE__*/ _jsx(Provider, {
                    children: posts.map((post, index)=>/*#__PURE__*/ _jsx(TopicPageViewsLabelPostsPost, {
                            post: post,
                            index: index
                        }, post.id))
                })
            }))
        ]
    });
};
export default TopicPageViewsLabelPosts;
